import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";
import { useToolbarButtonTooltip } from "./useToolbarButtonTooltip";
import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";

interface ClosePositionProps extends ButtonProps {}

export const ClosePosition = (props: ClosePositionProps) => {
  const { selectedPositionsCount, isOnlyClosedPositionsSelected } = useTableInstanceContext();

  const noPositionSelected = selectedPositionsCount === 0;
  const onlyClosedPositionsSelected = isOnlyClosedPositionsSelected();
  const isDisabled = noPositionSelected || onlyClosedPositionsSelected;

  const tooltipProps = useToolbarButtonTooltip("close");

  return (
    <Button
      {...props}
      disabled={isDisabled}
      iconProps={{
        name: "trash-can",
        title: "trash-can"
      }}
      modifier="danger-secondary"
      tooltipProps={tooltipProps}
    >
      {appstr("Close")}
    </Button>
  );
};
